import { render, staticRenderFns } from "./viewMatchScore.vue?vue&type=template&id=1103147c&scoped=true&"
import script from "./viewMatchScore.vue?vue&type=script&lang=js&"
export * from "./viewMatchScore.vue?vue&type=script&lang=js&"
import style0 from "./viewMatchScore.vue?vue&type=style&index=0&id=1103147c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1103147c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VLayout})
